import cx from 'classnames';
import { Button, SimpleText } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { LIBRARY_CONTENT_TYPE } from 'common.components/constants';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { useLessonViewParams } from 'common.components/lesson-view.index/hooks/use-lesson-view-params';
import * as lessonSelectors from 'common.components/lesson/selectors';

import * as actions from '../../lesson-view.store/actions';

export const EditAssignmentButton = () => {
    const { subject } = useLessonViewParams();
    const dispatch = useDispatch();
    const cLessonId = useSelector(lessonSelectors.getCLessonId);
    const courseId = useSelector(getCurrentYearCourseId);
    const activeSubscriptionSlug = useSelector((store) => {
        return lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId });
    });

    const onClickButton = () => {
        dispatch(actions.setShouldShowAssignmentSettings(true));

        ym('reachGoal', 'teacher_lesson_creation_preferences', {
            subject,
            contentType: LIBRARY_CONTENT_TYPE.COURSE_LESSON,
            clessonId: cLessonId,
            subscription_slug: activeSubscriptionSlug,
        });
    };

    return (
        <Button
            className={cx('side-panel__action-button', 'qa_edit-assignment-button')}
            onClick={onClickButton}
            view={Button.VIEW.PSEUDO}
        >
            <SimpleText id="lessonModal.header.assignmentSettings" />
        </Button>
    );
};
